// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  createMasterData,
  deleteMasterData,
  getDetailMasterData,
  getListMasterData,
  updateMasterData,
} from './masterDataThunk';

export interface IMasterDataState {
  isLoading: boolean;
  isRefreshMasterDataList: boolean;
}

export const initialState: IMasterDataState = {
  isLoading: false,
  isRefreshMasterDataList: false,
};

const masterDataSlice = createSlice({
  name: 'masterData',
  initialState,
  reducers: {
    setRefreshMasterDataList(state, action) {
      state.isRefreshMasterDataList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list master data
    builder
      .addCase(getListMasterData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListMasterData.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(getListMasterData.rejected, (state) => {
        state.isLoading = false;
      });

    // GET: Get detail master data
    builder
      .addCase(getDetailMasterData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDetailMasterData.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(getDetailMasterData.rejected, (state) => {
        state.isLoading = false;
      });

    // POST: Create master data
    builder
      .addCase(createMasterData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createMasterData.fulfilled, (state) => {
        state.isLoading = false;
        state.isRefreshMasterDataList = true;
      })
      .addCase(createMasterData.rejected, (state) => {
        state.isLoading = false;
      });

    // PUT: Update master data
    builder
      .addCase(updateMasterData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateMasterData.fulfilled, (state) => {
        state.isLoading = false;
        state.isRefreshMasterDataList = true;
      })
      .addCase(updateMasterData.rejected, (state) => {
        state.isLoading = false;
      });

    // DELETE: Delete master data
    builder
      .addCase(deleteMasterData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteMasterData.fulfilled, (state) => {
        state.isLoading = false;
        state.isRefreshMasterDataList = true;
      })
      .addCase(deleteMasterData.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

// Action
export const masterDataActions = masterDataSlice.actions;

// Selectors
export const selectIsRefreshListMaster = (state: RootState) => state.masterData.isRefreshMasterDataList;

// Reducer
const masterDataReducer = masterDataSlice.reducer;
export default masterDataReducer;
